import type {ComponentType} from 'react';

import classNames from 'classnames';

import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import type {EntityTypeFromApi} from '../../../../../ui/core/nutshell-fields/types';

import styles from './nutshell-field-card-content.module.css';

type NutshellFieldCardContentVariant = 'small' | 'normal';

interface Props {
    label: string;
    icon: ComponentType<any>;
    iconColor: string;
    subtitle: string;
    entityType: EntityTypeFromApi;
    variant?: NutshellFieldCardContentVariant;
}

export function NutshellFieldCardContent(props: Props) {
    const Icon = props.icon;

    const isSmall = props.variant === 'small';

    const entityIconClassName = classNames(styles['entity-icon'], {
        [styles['entity-icon--small']]: isSmall,
        [styles['entity-icon--leads']]: props.entityType === 'Leads',
    });

    return (
        <Stack spacing={isSmall ? 2 : 4}>
            <Body
                color='dark'
                isBold={true}
                textAlign='left'
                wrapAnywhere={true}
                size={isSmall ? 'small' : 'normal'}
            >
                {props.label}
            </Body>
            <Stack isHorizontal={true} spacing={isSmall ? 4 : 6} alignItems='center'>
                <div className={entityIconClassName}>
                    <Icon size={isSmall ? 16 : 20} color={props.iconColor} wrapWithDiv={false} />
                </div>
                <Body size={isSmall ? 'mini' : 'small'} color='light'>
                    {props.subtitle}
                </Body>
            </Stack>
        </Stack>
    );
}
